import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClaimsRoutingModule } from './claims-routing.module';

import { SharedTranslateLazyModule } from '../shared/shared-translate-lazy.module';
import { CommonUtilityModule } from '../shared/common-utility.module';
import { LeftMenuModule } from '../shared/left-menu.module';
import { PatientsComponent } from './patients/patients.component';
import { NewComponent } from './new/new.component';
import { PatientHistoryComponent } from './patient-history/patient-history.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  //schemas:[CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [PatientsComponent, NewComponent, PatientHistoryComponent],
  imports: [
    
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ClaimsRoutingModule,
    SharedTranslateLazyModule,
    CommonUtilityModule,
    LeftMenuModule,
    
    MatAutocompleteModule,
    
    MatInputModule,
  
    MatSelectModule
    
  ]
})
export class ClaimsModule { }
